"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _slugify = _interopRequireDefault(require("slugify"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Field = _interopRequireDefault(require("./Field"));

var _SubmitButton = _interopRequireDefault(require("./SubmitButton"));

var _FormContext = _interopRequireDefault(require("./FormContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var filterChangeOutput = function filterChangeOutput(e) {
  // case for default input
  var target = e.target;

  if (target) {
    var value = target.type === 'checkbox' ? target.checked : target.value;
    var name = (0, _slugify["default"])(target.name);
    return {
      name: name,
      value: value
    };
  } // case for custom component (<Radios />, <Checkbox />, <Checkboxes />)


  if (e.name) {
    var output = {
      name: (0, _slugify["default"])(e.name),
      value: e.value
    };
    return output;
  }
};

var filterBlurOutput = function filterBlurOutput(e) {
  return e.name ? e.name : (0, _get["default"])(e, 'target.name');
};
/**
 * TODO: find a cleaner way
 * Flatten properties
 * input: {
 *    firstName: { default: 'Chuck' },
 *    lastName: {default: 'Norris' }
 * }
 * output: {
 *    firstName: 'Chuck',
 *    lastName: 'Norris'
 * }
 */


var getDefaultInitialValues = function getDefaultInitialValues(schemaProperties) {
  return Object.keys(schemaProperties).reduce(function (acc, currentValue) {
    if (schemaProperties[currentValue] && schemaProperties[currentValue]["default"]) {
      acc[currentValue] = schemaProperties[currentValue]["default"];
    }

    return acc;
  }, {});
};

var cleanValidationErrors = function cleanValidationErrors(validationErrors, touched) {
  var touchedKeys = Object.keys(touched);
  return (0, _pick["default"])(validationErrors, touchedKeys);
};

var Form = function Form(_ref) {
  var formSchema = _ref.formSchema,
      validation = _ref.validation,
      uiSchema = _ref.uiSchema,
      components = _ref.components,
      loading = _ref.loading,
      errorMessage = _ref.errorMessage,
      children = _ref.children,
      onSubmit = _ref.onSubmit,
      submitButton = _ref.submitButton,
      _ref$requireMessage = _ref.requireMessage,
      requireMessage = _ref$requireMessage === void 0 ? 'This field is mandatory' : _ref$requireMessage,
      props = _objectWithoutProperties(_ref, ["formSchema", "validation", "uiSchema", "components", "loading", "errorMessage", "children", "onSubmit", "submitButton", "requireMessage"]);

  if (!formSchema || !Object.keys(formSchema).length) {
    throw 'formSchema attribute is mandatory.';
  }

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      touched = _useState2[0],
      setTouched = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      errors = _useState4[0],
      setErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(getDefaultInitialValues(formSchema.properties)),
      _useState6 = _slicedToArray(_useState5, 2),
      values = _useState6[0],
      setValues = _useState6[1]; // forceTouched is true only when the user hit the submit button.
  // So when its not, it means that the blur function is triggered.


  var validateForm =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(forceTouched) {
      var requiredErrors, validationErrors, keyProperties, requiredToRemove, newErrors;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              requiredErrors = {};
              validationErrors = {}; // if its required with a value and there is current error, remove it

              if (formSchema.required) {
                keyProperties = Object.keys(formSchema.properties); // retrieve all the required field that is touched and without values

                requiredErrors = keyProperties.reduce(function (acc, curr) {
                  if (formSchema.required.includes(curr) && (forceTouched ? true : touched[curr]) && !values[curr]) acc[curr] = requireMessage;
                  return acc;
                }, {}); // get all errors to remove

                requiredToRemove = keyProperties.filter(function (k) {
                  return formSchema.required.includes(k) && (forceTouched ? true : touched[k]) && values[k];
                });
                requiredErrors = (0, _omit["default"])(requiredErrors, requiredToRemove);
              }

              if (validation && typeof validation === 'function') {
                validationErrors = validation(values, touched); // Here, after running validation(), we do not want to show errors on fields that are not touched yet.

                if (!forceTouched) {
                  validationErrors = cleanValidationErrors(validationErrors, touched);
                }
              }

              newErrors = _objectSpread({}, validationErrors, requiredErrors);
              setErrors(newErrors);
              return _context.abrupt("return", newErrors);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function validateForm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleChange = function handleChange(e) {
    var _filterChangeOutput = filterChangeOutput(e),
        name = _filterChangeOutput.name,
        value = _filterChangeOutput.value;

    setTouched(_objectSpread({}, touched, _defineProperty({}, name, true)));
    setValues(_objectSpread({}, values, _defineProperty({}, name, value)));
  };

  var handleBlur =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(e) {
      var name;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // set touched values for the selected name
              name = filterBlurOutput(e);
              name && setTouched(_objectSpread({}, touched, _defineProperty({}, name, true)));
              _context2.next = 4;
              return validateForm();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleBlur(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSubmit =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(e) {
      var newErrors;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();
              _context3.next = 3;
              return validateForm(true);

            case 3:
              newErrors = _context3.sent;
              _context3.t0 = onSubmit;

              if (!_context3.t0) {
                _context3.next = 8;
                break;
              }

              _context3.next = 8;
              return onSubmit(values, newErrors);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmit(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var childrenButton = _react["default"].createElement(_SubmitButton["default"], null);

  if (submitButton && typeof submitButton === 'function') {
    childrenButton = submitButton(values);
  }

  var ctx = {
    properties: formSchema.properties,
    handleChange: handleChange,
    handleBlur: handleBlur,
    values: values,
    setValues: setValues,
    touched: touched,
    setTouched: setTouched,
    errors: errors,
    setErrors: setErrors,
    uiSchema: uiSchema,
    components: components,
    required: formSchema.required
  };
  var formProperties = (0, _get["default"])(formSchema, 'properties');
  var newChildren = !children && Object.keys(formProperties).map(function (name, i) {
    var props = _objectSpread({
      key: i,
      property: formSchema.properties[name],
      error: errors[name],
      disabled: loading,
      value: values[name] || '',
      name: name,
      onChange: handleChange,
      onBlur: handleBlur
    }, uiSchema && uiSchema[name] ? {
      uiProperty: uiSchema[name]
    } : {}, formSchema.required ? {
      required: formSchema.required.includes(name)
    } : {});

    if (components) return components(props);
    return _react["default"].createElement(_Field["default"], props);
  }).filter(function (f) {
    return f;
  });
  return _react["default"].createElement(_FormContext["default"].Provider, {
    value: ctx
  }, _react["default"].createElement("form", _extends({
    onSubmit: handleSubmit
  }, props), newChildren, childrenButton));
};

var _default = Form;
exports["default"] = _default;